<template>
  <v-container>
    <div class="text-h4">What are your outpulsed digits?</div>
    <v-select
      label="Outpulsed Digits"
      :value="currentOPD"
      :items="opds"
      @input="setOPD"
    ></v-select>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'OutpulsedDigits',
  data() {
    return {};
  },
  methods: {
    ...mapActions(['updateStoreFormData']),
    setOPD(newVal) {
      this.updateStoreFormData({
        data: newVal,
        main: this.getProductIdSelected,
        sub: 'opd',
      });
    },
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo']),
    currentOPD() {
      const productInfo = this.getProductInfo();
      return productInfo.opd;
    },
    opds() {
      return [
        { text: '10', value: 10 },
        { text: '7', value: 7 },
        { text: '5', value: 5 },
        { text: '4', value: 4 },
        { text: '3', value: 3 },
        { text: 'Unknown', value: -1 },
      ];
    },
  },
};
</script>
